<template>
  <footer  class="Footer" v-if="response">
    <div class="Footer_wrapper">
      <div class="Footer_content">
        <div class="Footer_infos" >
          <router-link to="/"><img :src="response.logo.url" alt="So Beautiful By Sarah"/></router-link>
            <prismic-rich-text field="footer_adresse" :field="response.adresse" />
        </div>

        <div class="Footer_social">
          <a v-for="(social, i) in response.socials" :key="i" :href="social.link.url" target="_blank"><i :class="social.icon"></i></a>
        </div>
      </div>

       <div class="Footer_mentions">
         © <span v-html="yearDate"></span> - <router-link to="/">So Beautiful By Sarah</router-link> - <router-link to="/mentions_legales">Mentions légales</router-link>
       </div>
     </div>
  </footer>
</template>

<script>
import PrismicFetch from "@/mixins/prismicFetch";
  export default {
    name: "Footer",
      mixins: [ PrismicFetch ],
    data() {
      return {
        yearDate: '2020'
      }
    },
    mounted()
    {
      this.yearDate = new Date().getFullYear()
    },
      created() {
        this.getContent('footer')
      }
  }
</script>

<style lang="stylus" >
.Footer
  background-color $darker-beige

  a:hover
    color $dark-beige

  &_wrapper
    padding 90px 0 0

    @media $small
      padding 60px 0 0

  &_content
    font-family $ftertiary
    letter-spacing 2px
    text-transform uppercase
    text-align center

    p, a
      color white

  &_social
    margin 40px 0 70px

    @media $small
      margin 35px 0 50px

    a
      margin-right 15px

      &:last-child
        margin-right 0


  &_infos

    img
      width 200px
      padding-bottom 40px

      @media $small
        padding-bottom 35px

    a
      display block
      color white

      &:hover
        color white

  &_mentions
    padding-bottom 20px
    font-size 12px
    color white
    text-align center

    a
      font-size 12px
      color white

</style>
